const searchPageRedirect = (searchValue) => {
  const params = searchValue ? `?query=${searchValue}` : '';
  window.location.href = encodeURI(`/search${params}`);
};

export default searchPageRedirect;
